<template>
  <div id="settings">
    <section>
      <h2>Settings</h2>
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
